import { CButton } from "@coreui/react";
import { faAngleLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "@mui/material";
import CustomIcon from "components/icons/CustomIcon";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import style from "./ShippingInfoLayout.module.css";
import NiceModal from "@ebay/nice-modal-react";
import MypageContentHeader from "../header/MypageContentHeader";
import { medusaRequester, storeRequester } from "App";
import ShippingInfomation from "routes/front/main/shopping/orderSummary/ShippingInfomation";
import ShippingInfoList from "./ShippingInfoList";

function ShippingInfoLayout() {
  const navigate = useNavigate();
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName } = useContext(AuthContext);
  const [shippingInfos, setShippingInfos] = useState([]);
  const [isAdd, setIsAdd] = useState(false);
  const [currentCustomer, setCurrentCustomer] = useState();
  const onModifyClick = (id) => {
    NiceModal.show("shippingInfoEditModal", {
      data: shippingInfos[id],
      onClose: onEditModalClose,
    });
  };

  const onEditModalClose = () => {
    
  };


  useEffect(() => {
    if (userName) {
      storeRequester.getCurrentCustomer(
        { expand: "shipping_addresses" },
        ({ customer }) => {
          setCurrentCustomer(customer);
          setShippingInfos(customer.shipping_addresses);
        }
      );
    } else {
      setCurrentCustomer(null);
    }
  }, [userName, isAdd]);


  const btnStyle = {
    backgroundColor: "white",
    borderRadius: "3px",
    border: "1px solid var(--main-color)",
    padding: "0",
    height: "30px",
    width: "90px",
    fontSize: "var(--font-size)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--main-color)",
  };

  const modifyBtnStyle = {
    backgroundColor: "white",
    borderRadius: "3px",
    border: "1px solid var(--main-color)",
    padding: "0",
    height: "30px",
    width: "60px",
    fontSize: "var(--font-size)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--main-color)",
  };
  const deleteBtnStyle = {
    backgroundColor: "white",
    borderRadius: "3px",
    border: "1px solid var(--line-color)",
    padding: "0",
    height: "30px",
    width: "60px",
    fontSize: "var(--font-size)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--font-color)",
  };

  const AddToaddressBtnStyle = {
    backgroundColor: "var(--main-color)",
    borderRadius: "0",
    border: "none",
    padding: "0",
    height: "30px",
    width: "130px",
    fontSize: "var(--font-size-lg)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  };

  const deleteSelection = (index) => { };

  return (
    <div>
        <VerticalFlex backgroundColor={"white"}>
          <FlexChild>
            <VerticalFlex>
              <FlexChild>
                <ShippingInfoList
                  shippingInfos={shippingInfos}
                  callback={deleteSelection}
                  setIsAdd={setIsAdd}
                />
              </FlexChild>
            </VerticalFlex>
          </FlexChild>
        </VerticalFlex>
    </div>
  );
}

export default ShippingInfoLayout;
